<div class="mobile-shell">
  <header class="mobile-shell__topbar">
    <div class="mobile-shell__leading">
      @if (showBack) {
        <button
          type="button"
          class="mobile-shell__back"
          (click)="onBack()"
          >
          <span aria-hidden="true">←</span>
        </button>
      }
      <a class="mobile-shell__brand" routerLink="/dashboard">
        {{ 'pages.dashboard.brand' | translate }}
      </a>
    </div>

    <div class="mobile-shell__meta">
      @if (tenantLabel) {
        <span class="mobile-shell__tenant">{{ tenantLabel }}</span>
      }
      <label class="mobile-shell__language">
        <span class="mobile-shell__language-label">{{ 'pages.mobile_shell.language.label' | translate }}</span>
        <select
          [value]="(currentLanguage$ | async) ?? 'pl'"
          (change)="setLanguage($any($event.target).value)"
          >
          @for (lang of supportedLanguages; track lang) {
            <option [value]="lang">{{ 'pages.mobile_shell.language.' + lang | translate }}</option>
          }
        </select>
      </label>
    </div>
  </header>

  <main class="mobile-shell__content">
    <ng-content></ng-content>
  </main>

  <app-bottom-nav [items]="navItems"></app-bottom-nav>
</div>
